import {MonoTypeOperatorFunction, pipe} from 'rxjs';
import {filter} from 'rxjs/operators';

export function filterNull<T>(): MonoTypeOperatorFunction<T> {
  return pipe(filter((val: T): boolean => val !== null));
}

export function filterUndefined<T>(): MonoTypeOperatorFunction<T> {
  return pipe(filter((val: T): boolean => val !== undefined));
}

export function filterNullOrUndefined<T>(): MonoTypeOperatorFunction<T> {
  return pipe(filterNull(), filterUndefined());
}
